<script>
    import workspaceService from "../../services/workspace.js";
    import { notificate } from "../../services/notification.js";
    import { user } from "../user/user.state.svelte.js";
    import { format } from "svelte-i18n";
    import BreadcrumNav from "../../components/breadcrum-nav.svelte";

    let level_selected = $state(0);
    let show_message = $state(false);

    const levels = ["basic", "intermediate", "advanced"];

    const level_values = {
        basic: {
            title: $format("page.phishing.level.basic.title"),
            label: $format("page.phishing.level.basic.label"),
            text: $format("page.phishing.level.basic.goal.list"),
            name: "basic",
        },
        intermediate: {
            title: $format("page.phishing.level.intermediate.title"),
            label: $format("page.phishing.level.intermediate.label"),
            text: $format("page.phishing.level.intermediate.goal.list"),
            name: "intermediate",
        },
        advanced: {
            title: $format("page.phishing.level.advanced.title"),
            label: $format("page.phishing.level.advanced.label"),
            text: $format("page.phishing.level.advanced.goal.list"),
            name: "advanced",
        },
    };

    const selectLevelFromCard = (level) => level_selected = level;

    const handlePhishingSolicit = async () => {
        let result = await notificate('confirm_phishing', "modal", {});
        if (!result.isConfirmed) {
            return false;
        }
        workspaceService.phishingSolicit(level_selected)
            .then(()=>{
                show_message = true;
                return notificate("request_ok")
            })
            .catch(error=>{
                return notificate("500");
            })
        ;
    };
</script>

<svelte:head>
    <style>
        .feature-list > li::before,
        .feature-list > li > ul > li:before {
            content: "✓";
            color: #16a34a;
            font-weight: 600;
        }
        .feature-list{
            padding-left: 0 !important;
        }
        .feature-list > li > ul {
            list-style: none;
        }
        .feature-list > li > ul > li {
            line-height: 2;
        }
    </style>
</svelte:head>
<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-fish fa-xs"></i>
                    {$format("layout.sidebar.phishing")}
                </h1>
            </div>
            <div class="col-6">
                <BreadcrumNav
                    routes={[
                        {
                            label: $format(
                                "components.breadcrumb.phishing_solicit",
                            ),
                        },
                    ]}
                />
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" style="margin-top: 0;">
                        <div>
                            {$format("page.phishing.description")}
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div class="card-title pt-3 text-center">
                        <h3 class="mt-3 mb-3">
                            {$format("page.phishing.service_level_title")}
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="level-grid">
                            {#each levels as level, idx (crypto.randomUUID())}
                                <div class="card level-card" aria-label="select level" onclick={()=>selectLevelFromCard(idx+1)}>
                                    <div class="card-header">
                                        <div class="level-text">
                                            <div class="level-title">
                                                {level_values[level].title}
                                            </div>
                                            <div class="level-subtitle">
                                                {level_values[level].label}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body">
                                        <p>
                                            <strong
                                                >{$format(
                                                    `page.phishing.level.${level_values[level].name}.goal.title`,
                                                )}</strong
                                            >:
                                            {$format(
                                                `page.phishing.level.${level_values[level].name}.goal.text`,
                                            )}
                                        </p>

                                        <div class="card-section-title">
                                            {$format(
                                                `page.phishing.level.${level_values[level].name}.goal.list_title`,
                                            )}
                                        </div>

                                        <ul class="feature-list">
                                            {@html level_values[level].text}
                                        </ul>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                    <footer class="phishing-footer mt-3">
                        <p>
                            <select
                                class="form-control w-25"
                                style="margin: 0 auto;"
                                bind:value={level_selected}
                            >
                                <option value={0} selected disabled>
                                    {$format(
                                        "page.phishing.select",
                                    )}
                                </option>
                                {#each levels as level, idx (crypto.randomUUID())}
                                    <option value={idx+1}>
                                        {level_values[level].title}
                                    </option>
                                {/each}
                            </select>
                        </p>
                        {#if user.data.role != "viewer"}
                            <div class="text-center pb-5">
                                <button
                                    class="btn btn-success mt-3 w-25"
                                    onclick={handlePhishingSolicit}
                                    disabled={!level_selected}
                                    >{$format(
                                        "buttons.phishing_solicit",
                                    )}</button
                                >
                            </div>
                        {:else}
                            <div
                                class="alert alert-info w-50 mb-5"
                                style="margin: 0 auto; text-align: left;"
                            >
                                <h5>
                                    <i class="icon fas fa-info"></i>{$format(
                                        "page.phishing.info",
                                    )}
                                </h5>
                                {$format("page.phishing.admin_message")}
                            </div>
                        {/if}
                        {#if show_message}
                            <div class="mt-3 alert alert-success w-50 ms-auto me-auto mb-5 text-center">
                                {$format("notifications.request_success")}
                            </div>
                        {/if}
                    </footer>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    /* ================================
   GRID DE TARJETAS
================================ */

    .level-grid {
        display: grid;
        grid-template-columns: repeat(12, 4fr);
        gap: 24px;
        width: 1280px;
        margin: 0 auto;
    }

    /* ================================
   TARJETA
================================ */

    .level-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        background: white;
        grid-column: span 4;
        cursor: pointer;
    }

    .level-card:hover {
        border: 1px solid white;
    }

    .level-card:nth-child(4) {
        grid-column-start: 3;
        grid-column-end: 7;
    }

    .level-card:nth-child(5) {
        grid-column-start: 7;
        grid-column-end: 11;
    }

    .level-card .card-body {
        padding-bottom: 0 !important;
    }

    /* ================================
   HEADER DE LA TARJETA
================================ */

    .level-card .card-header {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        /* asegura altura consistente */
        min-height: 64px;
    }

    .level-card p {
        height: 72px;
    }

    .level-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .level-title {
        font-weight: 600;
        font-size: 24px;
    }

    .level-subtitle {
        font-size: 18px;
        color: #6b7280;
    }

    /* ================================
   BADGE CIRCULAR DEL ICONO
================================ */

    .level-icon {
        width: 42px;
        height: 42px;
        border-radius: 50%;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 20px;

        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    /* ================================
   COLORES POR NIVEL
================================ */

    .level-1 {
        background: #f3f4f6;
        color: #4b5563;
    }

    .level-2 {
        background: #e8f1ff;
        color: #2563eb;
    }

    .level-3 {
        background: #e6f9f7;
        color: #0f766e;
    }

    .level-4 {
        background: #e9f9ef;
        color: #16a34a;
    }

    .level-5 {
        background: #f3f4f6;
        color: #111827;
    }

    /* ================================
   CUERPO DE LA TARJETA
================================ */

    .card-body {
        flex: 1;
        /*margin-top: 16px;*/
    }

    /* ================================
   SECCIONES INTERNAS
================================ */

    .card-section-title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 6px;
    }

    /* ================================
   LISTA DE CARACTERÍSTICAS
================================ */

    .feature-list {
        list-style: none;
        margin: 0;
    }

    /* ================================
   BOTÓN DE LA TARJETA
================================ */

    .card-footer {
        margin-top: 0 !important;
    }

    /* ================================
   HOVER SUAVE DEL ICONO
================================ */

    .level-icon {
        transition: transform 0.15s ease;
    }

    .card:hover .level-icon {
        transform: scale(1.05);
    }

    /* ================================
   RESPONSIVE
================================ */

    @media (max-width: 1024px) {
        .level-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 768px) {
        .level-grid {
            grid-template-columns: 1fr;
        }

        .feature-list {
            grid-template-columns: 1fr;
        }
    }
</style>
